"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_SKELETON = void 0;
const PRODUCT_SKELETON = exports.PRODUCT_SKELETON = 'product-skeleton';
